import styled, { css } from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';
import { colors } from 'components/styles/_variables';

export const Wrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  padding: 0 20px;
  ${respondTo.mobile`
    top: 5px;
  `}
`;

export const StepBlock = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 6px;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
`;

export const StepItem = styled.div`
  height: 4px;
  position: relative;
  //color: rgba(61, 191, 178, 1);
  //background-color: #FF7828;
  transition: 0.3s ease all;
  background: ${({ isFailed }) =>
    isFailed
      ? colors.theme.danger
      : 'linear-gradient(to left, rgba(255, 120, 40, .3)50%, rgba(255, 120, 40, 1) 50%) right'};
  background-size: 205%;
  //transition: .5s ease-out;
  // opacity: ${({ isActive }) => (isActive ? 1 : 0.3)};
  ${({ isActive, isCompleted }) =>
    isCompleted &&
    css`
      background-position: left;
      cursor: pointer;
    `}
  ${({ isActive }) =>
    isActive &&
    css`
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: -4px;
        background: linear-gradient(
            to left,
            rgba(61, 191, 178, 1) 50%,
            rgba(61, 191, 178, 1) 50%
          )
          right;
      }
    `}
`;
